export default __webpack_public_path__ + "img/df1e7e88b7333815d3a9a61e04146959.svg";